import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Container, Paper, Typography } from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

import { PublicFooter } from '../../maintenances/public';
import { theme } from '../../maintenances/public/theme';

const publicAxios = axios.create({
  withCredentials: false,
  headers: { 'Content-Type': 'application/json' },
});

function PublicFeedbackUnsubscribePage() {
  const { token } = useParams();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const unsubscribe = async () => {
      try {
        await publicAxios.get(`/api/public/feedback/unsubscribe/${token}/`);
        setSuccess(true);
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    unsubscribe();
  }, [token]);

  if (loading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: theme.colors.background }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box data-testid="public-feedback-unsubscribe-page" sx={{ minHeight: '100vh', bgcolor: theme.colors.background, display: 'flex', flexDirection: 'column' }}>
      <Box component="header" sx={{ backgroundColor: theme.colors.primary, padding: '16px 20px', color: 'white' }}>
        <Box sx={{ maxWidth: '600px', margin: '0 auto' }}>
          <Typography sx={{ fontSize: '20px', fontWeight: '700' }}>
            {t('public_feedback.feedback')}
          </Typography>
        </Box>
      </Box>

      <Container maxWidth="sm" sx={{ py: 6, flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Paper
          elevation={0}
          data-testid="unsubscribe-result"
          sx={{ p: 4, borderRadius: theme.radius.xl, boxShadow: theme.shadows.md, textAlign: 'center', width: '100%' }}
        >
          {success ? (
            <>
              <Typography sx={{ fontSize: '48px', mb: 2 }}>&#10003;</Typography>
              <Typography sx={{ fontSize: '18px', fontWeight: 600, color: theme.colors.text, mb: 1 }}>
                {t('public_feedback.unsubscribe_success_title')}
              </Typography>
              <Typography sx={{ fontSize: '14px', color: theme.colors.textMuted }}>
                {t('public_feedback.unsubscribe_success_message')}
              </Typography>
            </>
          ) : (
            <>
              <Typography sx={{ fontSize: '18px', fontWeight: 600, color: theme.colors.text, mb: 1 }}>
                {t('public_feedback.unsubscribe_error')}
              </Typography>
            </>
          )}
        </Paper>
      </Container>

      <PublicFooter />
    </Box>
  );
}

export default PublicFeedbackUnsubscribePage;
